import { lazy, Suspense } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export const AdminToolsPageTools = {
  FEATURE_SWITCH: 'feature-switch',
  TRIALS: 'trials',
  DOMAIN_SWITCHING: 'domain-switching',
  GO_LIVE: 'go-live',
  DELETE_REQUEST: 'delete-request',
  REROUTE_APPROVAL: 'reroute-approval',
  CLOSE_BUDGETS: 'close-budgets',
  NOTIFICATIONS: 'notifications',
  GENERATE_DATA: 'generate-data',
} as const

export interface AdminToolsPageParams {
  tool: string
}

// Page → Feature Set chunk code-splitting (org-management Suspense pattern)
const AdminToolsShellViewChunk = lazy(() =>
  import('../../feature-sets/AdminToolsShellView').then(
    ({ AdminToolsShellView }) => ({
      default: AdminToolsShellView,
    })
  )
)

export const AdminToolsPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.adminToolsTitle)}
      breadcrumbs={[{ name: intl.formatMessage(messages.adminToolsTitle) }]}
    >
      <div data-testid='admin-tools-page'>
        <Suspense fallback={null}>
          <AdminToolsShellViewChunk />
        </Suspense>
      </div>
    </Page>
  )
}
